/*
 * Qoloriqo — accordéon exclusif (round 34).
 * Sur un bloc `accordion` marqué [data-exclusive], ouvrir une rangée referme
 * automatiquement les autres du même groupe. On agit uniquement sur l'attribut
 * natif `open` de <details> : l'état d'accessibilité (summary => expanded/
 * collapsed exposé par le navigateur) reste donc synchronisé sans code en plus.
 *
 * L'évènement `toggle` ne bulle pas, mais il traverse la phase de capture :
 * un seul écouteur en capture sur `document` suffit et survit aux re-rendus
 * de section Shopify.
 */
(() => {
  if (window.__qoloriqoAccordionExclusive) return;
  window.__qoloriqoAccordionExclusive = true;

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      const group = details.closest('.accordion[data-exclusive]');
      if (!group) return;

      group.querySelectorAll('details[open]').forEach((other) => {
        if (other !== details && other.closest('.accordion[data-exclusive]') === group) {
          other.open = false;
        }
      });
    },
    true
  );
})();
